<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <h4 class="header-title">Advanced Data Table</h4> -->
            <p class="text-muted font-13 mb-0"></p>
            <!-- Table -->
            <div>
              <b-card-code>
                <validation-observer ref="simpleRules">
                  <form @submit.prevent="submitForm">
                    <b-row>
                      <b-col md="4">
                        <b-form-group>
                          <label>Project Name</label>
                          <b-form-input v-model="project" placeholder="Enter project" />
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group v-if="User == 'admin'">
                          <label>Type</label>
                          <v-select
                            @input="getEmployee($event)"
                            v-model="branchname"
                            placeholder="None"
                            label="name"
                            :options="branchOptions"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="4" v-if="branchname && branchname.name !== 'All'">
                        <b-form-group>
                          <label
                            >Select
                            {{
                              branchname.name == "Admin" ? "Employee" : branchname.name
                            }}</label
                          >
                          <v-select
                            v-model="employee"
                            label="fullname"
                            placeholder="None"
                            :options="$store.getters['master/getUsers'](branchname.id)"
                            @input="handleClient"
                          >
                            <template
                              #option="{ name, profile_image, username, surname }"
                            >
                              <b-avatar :src="getprofileImage(profile_image)" />
                              <span class="font-weight-bolder">
                                {{ name }} {{ surname }}</span
                              ><span>({{ username }})</span>
                            </template>
                          </v-select>
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group>
                          <label>Select Client</label>
                          <v-select
                            v-model="client"
                            label="fullname"
                            placeholder="None"
                            :options="$store.state.master.customersSiteVisit"
                          >
                            <template #option="{ fullname, profile_image }">
                              <b-avatar :src="getprofileImage(profile_image)" />
                              <span class="font-weight-bolder"> {{ fullname }}</span>
                            </template>
                          </v-select>
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group>
                          <label>Vehicle No.</label>
                          <v-select
                            v-model="vehicleno"
                            placeholder="None"
                            :options="$store.state.master.vehicles"
                            label="vehicleno"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group>
                          <label>Status</label>
                          <v-select
                            v-model="status"
                            placeholder="None"
                            label="name"
                            :options="[
                              'All',
                              'Canceled',
                              'Pending',
                              'Accepted',
                              'Completed',
                            ]"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col md="4">
                        <b-form-group>
                          <label>Select Date</label>
                          <flat-pickr
                            value=""
                            class="form-control"
                            placeholder="Select Date"
                            :config="{
                              dateFormat: 'd/m/Y',
                              mode: 'range',
                            }"
                            @input="getdata($event)"
                            style="background-color: transparent"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                      <b-button
                        variant="primary"
                        class="ml-2"
                        @click="searchData"
                        :disabled="flag"
                      >
                        <feather-icon icon="SearchIcon" class="mr-50" />
                        <span class="align-middle">Search</span>
                      </b-button>
                    </div>
                  </form>
                </validation-observer>
              </b-card-code>
              <customer-modal
                v-if="$store.state.app.customerDetailsModal"
              ></customer-modal>
              <report-table :data="data" :columns="fields"> </report-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportTable from "../../../components/ReportTable.vue";
import axios from "@/components/axios";
import BCardCode from "@core/components/b-card-code";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import GoodTableColumnSearch from "../../../components/GoodTableColumnSearch.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Form from "@/components/form/Form.vue";
import moment from "moment";
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BFormTextarea,
  BFormDatepicker,
  BImgLazy,
  BAvatar,
} from "bootstrap-vue";
const baseApi = process.env.VUE_APP_APIENDPOINT;
export default {
  components: {
    vSelect,
    ReportTable,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    BCardCode,
    Form,
    GoodTableColumnSearch,
    BAvatar,
    BFormInput,
  },
  data() {
    return {
      flag: false,
      User: "",
      employee: "",
      project: "",
      branchname: "",
      data: "",
      startdate: "",
      enddate: "",
      result: "",
      data: "",
      data1: [],
      users: [],
      baseApi: process.env.VUE_APP_APIENDPOINT,
      accessToken: localStorage.getItem("accessToken"),
      fields: [
        {
          field: "arrivaldate",
          label: "Arrival Date",
        },
        {
          field: "cpempfranchise",
          label: "CP/Emp/Franchise Name",
        },
        {
          field: "cityname",
          label: "City Name",
        },
        {
          field: "mobileno",
          label: "Mobile No.",
        },
        {
          field: "clientname",
          label: "Client Name",
        },
        {
          field: "clientmobile",
          label: "Client Mobile No.",
        },
        {
          field: "noofperson",
          label: "No. of Person",
        },
        {
          field: "arrivefrom",
          label: "Arrive From",
        },
        {
          field: "pickuplocation",
          label: "Pickup Location",
        },
        {
          field: "sitevisitdate",
          label: "Site Visit Date",
        },
        {
          field: "droppoint",
          label: "Drop Point",
        },
        {
          field: "stay",
          label: "Stay Location",
        },
        {
          field: "visitassistant",
          label: "Site Assistant name",
        },
        {
          field: "vehicleno",
          label: "Vehicle No.",
        },
        {
          field: "drivername",
          label: "Visit Assistant Name",
        },
        {
          field: "idproof",
          label: "I'd Proof",
        },
        {
          field: "returndate",
          label: "Return Date",
        },
        {
          field: "source_type",
          label: "Source",
        },
        {
          field: "select_source",
          label: "Select Source",
        },
        {
          field: "site_visit_manager",
          label: "Site Visit Manager",
        },
        {
          field: "select_assistant",
          label: "Select Assistant",
        },
        {
          field: "noofperson",
          label: "No. Of Person",
        },
        {
          field: "arrivaldate",
          label: "Arrival Date",
        },
        {
          field: "arrivaltime",
          label: "Arrival Time",
        },
        {
          field: "travelby",
          label: "Travel By",
        },
        {
          field: "pickuppoint",
          label: "Pickup Point",
        },
        {
          field: "vehiclereq",
          label: "Vehicle Required",
        },
        {
          field: "vehicleno",
          label: "Vehicle No",
        },
        {
          field: "drivername",
          label: "Select Visit Assistant",
        },
        {
          field: "visittime",
          label: "Site Visit Time",
        },
        {
          field: "stay",
          label: "Stay",
        },
        {
          field: "departurdate",
          label: "Departure Date",
        },
        {
          field: "droptime",
          label: "Drop Time",
        },
        {
          field: "droplocation",
          label: "Drop Location",
        },
        {
          field: "project",
          label: "Site Visit Projects",
        },
        {
          field: "remarks",
          label: "remark",
        },
      ],
      projectOption: [],
      plots: [],
      employeeOptions: [],
      status: "",
      branchOptions: [
        { name: "Company Associate Partner", id: "companyassociatepartner" },
        { name: "Franchise", id: "franchise" },
        { name: "Employee", id: "employee" },
        { name: "All", id: "all" },
      ],
      client: "",
      vehicleno: "",
    };
  },
  watch: {
    "$store.state.app.user_data"(newValue, oldValue) {
      this.User = this.$store.state.app.user_data.role;
    },
  },
  mounted() {
    this.User = this.$store.state.app.user_data.role;
    if (this.User !== "admin") {
      this.getEmployee({ id: this.User });
    }
    this.$store.dispatch("master/getVehicle");
  },
  methods: {
    async getEmployee(e) {
      this.employee = [];
      if (e && e.id == "companyassociatepartner") {
        this.$store.dispatch("master/getCompanyassociatepartner");
      } else if (e && e.id == "franchise") {
        this.$store.dispatch("master/getFranchise");
      } else if (e && e.id == "employee") {
        this.$store.dispatch("master/getEmployee");
      }
    },
    getdata(selectedDates) {
      this.result = selectedDates.split(" to ");
      this.startdate = this.result[0];
      this.enddate = this.result[1];
    },
    handleClient() {
      if (this.employee && this.employee.id) {
        this.$store.dispatch("master/getCustomerBySiteVisit", this.employee.id);
      }
    },
    async searchData(tableData) {
      const obj = {
        startdate: this.startdate,
        enddate: this.enddate,
        team: this.employee ? this.employee.id : "",
        client: this.client ? this.client.id : "",
        status: this.status,
        vehicleno: this.vehicleno ? this.vehicleno.vehicleno : "",
      };
      this.flag = true;
      await axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        data: JSON.stringify(obj),
        url: `${this.baseApi}/sitevisitreport`,
      })
        .then((response) => {
          this.flag = false;

          this.data = response.data.data;

          this.data.map((item, index) => {
            // Arrival Date
            item.arrivaldate =
              item.arrivaldate == false || item.arrivaldate == "00/00/0000"
                ? "-"
                : moment(item.arrivaldate).format("DD/MM/YYYY");
            if (item.arrivaltime) {
              item.arrivaldate += " " + item.arrivaltime;
            }

            // Site Visit Date
            item.sitevisitdate =
              item.visitdate == false || item.visitdate == "00/00/0000"
                ? "-"
                : moment(item.visitdate).format("DD/MM/YYYY");
            if (item.visittime) {
              item.sitevisitdate += " " + item.visittime;
            }

            // Return Date
            item.returndate =
              item.departurdate == false || item.departurdate == "00/00/0000"
                ? "-"
                : moment(item.departurdate).format("DD/MM/YYYY");
            if (item.droptime) {
              item.returndate += " " + item.droptime;
            }

            // CP/Emp/Franchise Name - mapping from source
            item.cpempfranchise = item.source ? item.source.fullname : "-";

            // City Name - provided by backend via JOINs with related tables
            item.cityname = item.cityname || "-";

            // Mobile No. - provided by backend via JOINs with related tables
            item.mobileno = item.mobileno || "-";

            // Client Name
            item.clientname = item.clientname ? item.clientname.fullname : "-";

            // Client Mobile No. - provided by backend via JOINs with related tables
            item.clientmobile = item.clientmobile || "-";

            // No. of Person - existing field from sitevisit table
            item.noofperson = item.noofperson || "-";

            // Arrive From - provided by backend via JOINs with related tables
            item.arrivefrom = item.arrivefrom || "-";

            // Pickup Location - provided by backend via JOINs with related tables
            item.pickuplocation = item.pickuplocation || "-";

            // Drop Point - provided by backend via JOINs with related tables
            item.droppoint = item.droppoint || "-";

            // Stay Location
            item.stay = item.stay || "-";

            // Visit Assistant name - mapping from assistant
            item.visitassistant = item.assistant ? item.assistant.fullname : "-";

            // Vehicle No.
            item.vehicleno = item.vehicleno || "-";

            // Visit Assistant Name
            item.drivername = item.driver ? item.driver.fullname : "-";

            // I'd Proof - provided by backend via JOINs with related tables
            item.idproof = item.idproof || "-";

            // Remarks
            item.remarks = item.remarks ? item.remarks.remarks : "-";

            item.source_type = item.source_type || "-";
            item.select_source = item.select_source || "-";
            item.site_visit_manager = item.site_visit_manager || "-";
            item.select_assistant = item.select_assistant || "-";
            item.droptime = item.droptime ? item.droptime : "-";
            item.travelby = item.travelby || "-";
            item.pickuppoint = item.pickuplocation || "-";
            item.vehiclereq = item.vehiclereq || "-";
            item.droplocation = item.droppoint || "-";
            item.project = item.project || "-";
            // Status mapping (keeping for reference if needed elsewhere)
            if (item.active == 4) {
              item.status = "Completed";
            } else if (item.action == 0) {
              item.status = "Canceled";
            } else if (item.lock == 0) {
              item.status = "Accepted";
            } else {
              item.status = "Pending";
            }
          });
        })
        .catch((error) => {
          this.flag = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>

